(function () {
  function checkVisibility() {
    fetch("/cart.js")
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll(".cart-collection-section").forEach(function (section) {
          var threshold = parseInt(section.dataset.threshold, 10);
          var total = 0;
          cart.items.forEach(function (item) {
            if (!item.properties || item.properties._gift !== "true") {
              total += item.line_price;
            }
          });
          section.setAttribute("data-hidden", total >= threshold ? "true" : "false");
        });
      })
      .catch(function (err) {
        console.error("[cart-collection] Errore fetch carrello:", err);
      });
  }

  document.querySelectorAll(".cart-collection-section").forEach(function (section) {
    section.setAttribute("data-hidden", "true");
  });

  checkVisibility();

  document.addEventListener("cart:updated", function () {
    location.reload();
  });
})();